import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/Card';
export function Dashboard() {
  return <div className="space-y-6" data-id="element-404">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-405">Order Info</h1>

      <p className="text-slate-600" data-id="element-406">
        Below is information about the new orders placed by your customers this
        month/this week/today or since your last log in to the administrator
        area.
      </p>

      <Card data-id="element-407">
        <CardContent className="p-0" data-id="element-408">
          <div className="overflow-x-auto" data-id="element-409">
            <table className="w-full text-sm text-left" data-id="element-410">
              <thead className="bg-slate-800 text-white" data-id="element-411">
                <tr data-id="element-412">
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-413">
                    Status
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-414">
                    Since Last Login
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-415">
                    Today
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-416">
                    This Week
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700" data-id="element-417">
                    This Month
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-418">
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-419">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-420">
                    Processed
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-421">
                    34
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-422">
                    20
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-423">
                    66
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-424">189</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-425">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-426">
                    Failed/Declined
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-427">
                    2
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-428">
                    1
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-429">
                    3
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-430">10</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-431">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-432">
                    Not Finished
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-433">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-434">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-435">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-436">0</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-437">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-438">
                    Total Paid
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-439">
                    $1325.24
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-440">
                    $724.58
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-441">
                    $3078.7
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-442">$9063.84</td>
                </tr>
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>

      <div data-id="element-443">
        <Link to="/orders" className="text-blue-600 hover:text-blue-800 hover:underline text-sm font-medium" data-id="element-444">
          Order Search
        </Link>
      </div>
    </div>;
}